import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  CircularProgress,
  Box,
  FormControlLabel,
  Switch
} from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditAidantDialog = ({ open, aidantId, onClose, onAidantUpdated, apiUrl, token }) => {
  const [formData, setFormData] = useState({
    nom_aidant: '',
    prenom_aidant: '',
    email_aidant: '',
    telephone_aidant: '',
    adresse_aidant: '',
    ville_aidant: '',
    profession_aidant: '',
    client_id: '',
    actif_aidant: true,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open && aidantId) {
      const fetchAidant = async () => {
        setIsLoading(true);
        try {
          // Utilisation de la route admin correcte
          const response = await axios.get(`${apiUrl}/admin/aidants/${aidantId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = response.data.data || response.data;
          
          setFormData({
            nom_aidant: data.nom_aidant || '',
            prenom_aidant: data.prenom_aidant || '',
            email_aidant: data.email_aidant || '',
            telephone_aidant: data.telephone_aidant || '',
            adresse_aidant: data.adresse_aidant || '',
            ville_aidant: data.ville_aidant || '',
            profession_aidant: data.profession_aidant || '',
            client_id: data.client_id !== null ? data.client_id : '',
            actif_aidant: data.actif_aidant ?? true,
          });
        } catch (err) {
          toast.error('Erreur de chargement des informations');
          onClose();
        } finally {
          setIsLoading(false);
        }
      };
      fetchAidant();
    }
  }, [open, aidantId, apiUrl, token, onClose]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Envoi de la mise à jour vers la route admin
      await axios.put(`${apiUrl}/admin/aidants/${aidantId}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Aidant mis à jour avec succès');
      onAidantUpdated();
      onClose();
    } catch (err) {
      toast.error('Erreur lors de la mise à jour');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ fontWeight: 'bold', color: '#2B3674' }}>Modifier l'Aidant</DialogTitle>
        <DialogContent dividers>
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
              <CircularProgress sx={{ color: '#4318FF' }} />
            </Box>
          ) : (
            <Stack spacing={2} sx={{ mt: 1 }}>
              <Stack direction="row" spacing={2}>
                <TextField label="Nom" name="nom_aidant" value={formData.nom_aidant} onChange={handleChange} required fullWidth />
                <TextField label="Prénom" name="prenom_aidant" value={formData.prenom_aidant} onChange={handleChange} required fullWidth />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField label="Email" name="email_aidant" type="email" value={formData.email_aidant} onChange={handleChange} required fullWidth />
                <TextField label="Téléphone" name="telephone_aidant" value={formData.telephone_aidant} onChange={handleChange} fullWidth />
              </Stack>

              <Stack direction="row" spacing={2}>
                <TextField label="Ville" name="ville_aidant" value={formData.ville_aidant} onChange={handleChange} fullWidth />
                <TextField label="Profession" name="profession_aidant" value={formData.profession_aidant} onChange={handleChange} fullWidth />
              </Stack>

              <TextField label="Adresse" name="adresse_aidant" value={formData.adresse_aidant} onChange={handleChange} fullWidth />

              <Stack direction="row" spacing={2} alignItems="center">
                <TextField label="Client ID" name="client_id" type="number" value={formData.client_id} onChange={handleChange} fullWidth />
                
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.actif_aidant}
                      onChange={handleChange}
                      name="actif_aidant"
                      color="primary"
                    />
                  }
                  label="Actif"
                  sx={{ width: '100%' }}
                />
              </Stack>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit" disabled={isSubmitting || isLoading}>
            Annuler
          </Button>
          <Button type="submit" variant="contained" disabled={isSubmitting || isLoading} sx={{ bgcolor: '#4318FF', '&:hover': { bgcolor: '#3311CC' } }}>
            Mettre à jour
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditAidantDialog;